import { formFieldEdit } from '@wix/bi-logger-forms-platform-uou/v2';
import { useBi } from '@wix/form-fields';
import { useRef } from 'react';
export const useReportFieldEdit = (form)=>{
    const lastChangedFields = useRef([]);
    const bi = useBi();
    return (changedValues)=>{
        const changedFieldTargets = Object.keys(changedValues);
        const isEditingDifferentFields = changedFieldTargets.length !== lastChangedFields.current.length || changedFieldTargets.some((target, index)=>target !== lastChangedFields.current[index]);
        if (isEditingDifferentFields) {
            lastChangedFields.current = changedFieldTargets;
            changedFieldTargets.forEach((target)=>{
                const changedField = form?.fields?.find((field)=>field.target === target);
                bi.report(formFieldEdit({
                    field_id: changedField?.id,
                    field_label: changedField?.view?.label,
                    field_target: changedField?.target || undefined
                }));
            });
        }
    };
};

//# sourceMappingURL=use-report-field-edit.js.map